/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from 'react'
import { useSize } from './useSize'

export const useSlider = ({ margin }) => {
  const refContainer = useRef(null)
  const refSlider = useRef(null)
  const [position, setPosition] = useState(0)
  const [childsWidth, setChildsWidth] = useState([])
  const [leftStatus, setLeftStatus] = useState(false)
  const [rightStatus, setRightStatus] = useState(true)
  const [isActive, setIsActive] = useState(false)
  const { width: widthScream } = useSize()
  /*  const { width } = useDimension() */
  const moveRight = () => {
    if (position < childsWidth.length && rightStatus) {
      setPosition(p => p + 1)
    }
  }

  const moveLeft = () => {
    if (position > 0) {
      setPosition(p => p - 1)
      if (position - 1 === 0) {
        setLeftStatus(false)
      }
    }
  }

  useEffect(() => {
    if (position > 0 && !leftStatus) {
      setLeftStatus(true)
    }
    if (refSlider.current && childsWidth.length > 0) {
      const sliderElement = refSlider.current
      const width = refContainer?.current?.clientWidth || 0
      const childsSelected = childsWidth.filter(child => child.position <= position - 1)
      // console.log(childsSelected)
      const distance = childsSelected.reduce((acc, curr) => acc + curr.width, 0)
      const distanceTotal = childsWidth.reduce((acc, curr) => acc + curr.width, 0)
      const differenceDistance = distanceTotal - width
      if (distance > differenceDistance) {
        sliderElement.style.transform = `translateX(-${differenceDistance}px)`
        setRightStatus(s => !s)
      } else {
        sliderElement.style.transform = `translateX(-${distance}px)`
        if (rightStatus === false) {
          setRightStatus(s => !s)
        }
      }
    }
  }, [position])

  useEffect(() => {
    if (refSlider.current) {
      const sliderElement = refSlider.current
      const width = refContainer?.current?.clientWidth || 0
      sliderElement.style.transition = 'transform 0.5s'
      const childs = refSlider.current.childNodes
      const childsData = []
      childs.forEach((child, index, listObj) => {
        const currentChild = child 
/*         currentChild.style.marginRight = `${margin}px` */
        currentChild.style.margin = `0 ${margin}px`
        childsData.push({
          position: index,
          width: currentChild.offsetWidth + margin*2
        })
        /* if (!(listObj.length - 1 === index)) {
          currentChild.style.marginRight = `${margin}px`
          childsData.push({
            position: index,
            width: currentChild.offsetWidth + margin
          })
        } else {
          childsData.push({
            position: index,
            width: currentChild.offsetWidth
          })
        } */
      })
      const distanceTotal = childsData.reduce((acc, curr) => acc + curr.width, 0)

      if (distanceTotal > width + 40) {
        setIsActive(true)
      } else {
        sliderElement.style.transform = `translateX(${0}px)`
        setIsActive(false)
      }
      setChildsWidth(childsData)
    }
  }, [widthScream])


  return {
    refContainer,
    refSlider,
    moveRight,
    moveLeft,
    isActive,
    leftStatus,
    rightStatus
  }
}
